import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { CursorPaginatorComponent } from '@app/shared/components/data-table/cursor-paginator/cursor-paginator.component';

@Component({
  selector: 'app-infiniscroll-cursor-paginator',
  templateUrl: './infiniscroll-cursor-paginator.component.html',
  styleUrl: './infiniscroll-cursor-paginator.component.scss',
  // TODO(onpush): extends CursorPaginatorComponent, whose public fields are mutated directly via
  // @ViewChild references from sibling data-source classes outside this migration's scope. See
  // cursor-paginator.component.ts for details. Keeping Eager.
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InfiniscrollCursorPaginatorComponent extends CursorPaginatorComponent {
  @Input() detailTemplate?: TemplateRef<any>;
  Math = Math;

  get isNextDisabled(): boolean {
    return this.loading ? true : !this.nextPage?.cursor;
  }
}
